import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

const StyledSideBarLink = styled(NavLink)`
  position: relative;
  width: 100%;

  .sidebar-link {
    height: 40px;
    display: flex;
    align-items: center;
    transition: 0.2s;
    padding: 0 11px;
    border-radius: 6px;
    background-color: transparent;

    .link-icon {
      height: 24px;
      width: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 1rem;
      color: ${({ theme }) => theme.colors.gray[600]};
      position: relative;
      flex-shrink: 0;

      svg {
        height: 24px;
        width: 24px;

        path {
          stroke-width: 1.8px;
        }
      }
    }

    .link-notification {
      position: absolute;
      right: -5px;
      top: -5px;
      height: 16px;
      background: ${({ theme }) => theme.colors.green[500]};
      min-width: 16px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 3px;
      font-size: 10px;
      color: ${({ theme }) => theme.colors.background};
      font-weight: 600;
      border-radius: 50%;
    }

    .link-label {
      font-weight: 600;
      font-size: 15px;
      line-height: 19px;
      display: flex;
      align-items: center;
      letter-spacing: 0.02rem;
      text-transform: capitalize;
      color: ${({ theme }) => theme.colors.gray[600]};
      white-space: nowrap;

      .new-label {
        pointer-events: none;
        display: flex;
        margin-left: 12px;
        font-weight: 700;
        font-size: 10px;
        background: ${({ theme }) => theme.colors.green[500]};
        padding: 0 5px 0 7px;
        border-radius: 2px;
        color: ${({ theme }) => theme.colors.background};
        height: 17px;
        align-items: center;
        justify-content: center;
        letter-spacing: 0.14rem;
      }
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.gray[100]};
    }
  }

  &.active {
    .sidebar-link {
      background-color: ${({ theme }) => theme.colors.green[50]};

      .link-icon,
      .link-label {
        color: ${({ theme }) => theme.colors.green[500]};
      }
    }
  }
`

export default StyledSideBarLink
